// Module
var code = "<div class=\"grid_division\"> <div class=\"main_grid\"> <div> <div class=\"mishion_history\"> <div class=\"mission_title\">Titles</div> </div> <div class=\"text-right\"> <a class=\"btn btn-secondary\" ui-sref=\"^.add\"> <span> <i class=\"fa fa-plus\"></i> ADD Title </span> </a> </div> <titles-main-grid> </titles-main-grid> </div> </div> </div>";
// Exports
var _module_exports = code;;
var path = 'user/pages/title/index.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;